/**
 * Video intro block — front-end interactivity (viewScript, loaded only on
 * pages that use this block).
 *
 * The poster image + play button rendered by render.php is a facade: nothing
 * is requested from YouTube/Vimeo until the visitor clicks. On click the
 * button is replaced by the real iframe, whose src already carries
 * autoplay=1, so the video starts immediately (the click counts as a user
 * gesture, so it may play with sound).
 */

function playVideo(facade) {
	const src = facade.dataset.videoSrc;
	if (!src) return;

	const iframe = document.createElement('iframe');
	iframe.src = src;
	iframe.className = 'absolute inset-0 h-full w-full';
	iframe.title = facade.dataset.videoTitle || '';
	iframe.setAttribute(
		'allow',
		'autoplay; fullscreen; picture-in-picture; encrypted-media'
	);
	iframe.setAttribute('allowfullscreen', '');

	facade.replaceWith(iframe);
}

function initVideoFacades() {
	document
		.querySelectorAll('[data-qr-part="video-facade"]')
		.forEach((facade) => {
			facade.addEventListener('click', () => playVideo(facade));
		});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initVideoFacades);
} else {
	initVideoFacades();
}
